// @flow

import uniq from 'lodash.uniq';
import {getAllCheckedTextList} from './getAllCheckedTextList';

import type {GetCheckedTextList} from '../typedef';

export const getCheckedTextListUniq: GetCheckedTextList = (data, checkedIdsList) =>
    uniq(getAllCheckedTextList(data, checkedIdsList));
